import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
} from '@mui/material';

import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import EmergencyIcon from '@mui/icons-material/ReportProblem';

export default function DiagnosisHistorySection({ onDiagnosesUpload, onHCCUpload, onAcuteUpload }) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (name, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Diagnoses and History" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Current Diagnoses */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <MedicalInformationIcon sx={{ mr: 1 }} /> Active Diagnoses (ICD-10)
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onDiagnosesUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'active_diagnoses_template.txt',
                    'E11.9 - Type 2 diabetes without complications - 2024-04-12\nI10 - Hypertension - 2023-11-01'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* HCC History */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <HistoryEduIcon sx={{ mr: 1 }} /> HCC Conditions History
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onHCCUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'hcc_history_template.txt',
                    'I50.22 - Chronic systolic heart failure - Active\nJ44.9 - COPD unspecified - Resolved'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* Acute Conditions */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <EmergencyIcon sx={{ mr: 1 }} /> Recent Acute Conditions
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onAcuteUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'acute_conditions_template.txt',
                    'J06.9 - Acute upper respiratory infection - 2025-01-15\nR50.9 - Fever, unspecified - 2025-02-02'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
